<template>
  <div class="broadcast mb-3">
    <v-layout wrap>
      <v-flex xs12 sm8>
        <p class="text-truncate mt-1">{{ name }}</p>
      </v-flex>
      <v-flex xs12 sm4 text-xs-right>
        <v-btn
          v-if="isEdit"
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="handleEdit"
        >
          <em class="fas fa-pencil-alt" />
        </v-btn>
        <v-btn fab outline class="extra-small ma-1" color="primary" @click="handleCopyBroadcast">
          <em class="fas fa-copy" />
        </v-btn>
        <v-btn
          v-if="isDelete"
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="handleDelete"
        >
          <em class="fas fa-trash" />
        </v-btn>
        <v-btn
          v-if="isDetail"
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="handleSelect"
        >
          <em class="fas fa-eye" />
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4 class="grey--text text--lighten-1 caption mt-1">
        <div>
          {{ new Date(updatedAt || createdAt) | DateFormat('DD/MM/YYYY hh:mm A') }}
        </div>
        <div>{{ $t('Created by') }} {{ createdBy }}</div>
      </v-flex>
      <v-flex xs12 sm8 class="text-xs-left text-sm-right mt-1">
        <v-chip v-if="!!scheduledBy" color="info" text-color="white" small disabled>
          <v-avatar>
            <v-icon>access_time</v-icon>
          </v-avatar>
          {{ new Date(scheduledBy) | DateFormat('DD/MM/YYYY hh:mm A') }}
        </v-chip>
        <v-chip v-if="['draft'].includes(status)" color="grey" text-color="white" small disabled>{{
          $t('Draft')
        }}</v-chip>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    isDelete: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    isDetail: {
      type: Boolean,
      default: true
    },
    createdAt: {
      type: String,
      default: ''
    },
    updatedAt: {
      type: String,
      default: ''
    },
    createdBy: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: 'draft'
    },
    scheduledBy: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleEdit() {
      if (!this.isEdit) return
      this.$emit('edit')
    },
    handleCopyBroadcast() {
      this.$emit('copy')
    },
    handleDelete() {
      if (!this.isDelete) return
      this.$emit('delete')
    },
    handleSelect() {
      if (!this.isDetail) return
      this.$emit('select')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/LonBroadcastItem.vue